<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues"
    (pageChange)="handlePageChange($event)" (search)="onTableSearch($event)" (delete)="onDelete($event)">
</app-data-table>

{{ error }}